import { Command } from 'commander';
import chalk from 'chalk';
import { registerAgentsCrud } from './agents-crud.js';
import { AGENTS_WIP_BANNER } from '../../lib/agents-wip-banner.js';

// Command option interfaces for type safety (shared across submodules)
export interface ListOptions {
  limit: string;
  offset?: string;
  name?: string;
  status?: string;
}

export interface CreateOptions {
  data?: string;
  name?: string;
  slug?: string;
  systemPrompt?: string;
  model?: string;
  description?: string;
}

export interface UpdateOptions {
  data?: string;
  name?: string;
  systemPrompt?: string;
  model?: string;
  description?: string;
  status?: string;
}

export interface DeleteOptions {
  force?: boolean;
}

export interface ConfirmAnswer {
  confirm: boolean;
}

export function createAgentsCommand(): Command {
  const agents = new Command('agents')
    .description('Manage AI agents (CRUD only — optimization & evaluation are WIP)')
    .addHelpText('after', `
${AGENTS_WIP_BANNER}

Examples:
  ${chalk.dim('$')} mutagent agents list
  ${chalk.dim('$')} mutagent agents get <agent-id>
  ${chalk.dim('$')} mutagent agents create --name "Code Reviewer" --slug code-reviewer --system-prompt "You are a code reviewer..."
  ${chalk.dim('$')} mutagent agents create -d '{"name":"Code Reviewer","slug":"code-reviewer","systemPrompt":"You are..."}'
  ${chalk.dim('$')} mutagent agents update <agent-id> --name "Updated Name"
  ${chalk.dim('$')} mutagent agents delete <agent-id> --force

Subcommands:
  list, get, create, update, delete
    `);

  registerAgentsCrud(agents);

  return agents;
}
